import { arrayOf, shape, string } from 'prop-types';
import QuantityUnitType from './quantityUnitType';

const weatherConditionsType = shape({
  firstForecastTime: string,
  max_temperature: QuantityUnitType,
  min_temperature: QuantityUnitType,
  precipitation_probability: QuantityUnitType,
  precipitacion_amount: QuantityUnitType,
  spray_assist_index: arrayOf(string),
  weatherCondition: shape({
    data: arrayOf(string),
  }),
  wind_direction: QuantityUnitType,
  wind_speed: QuantityUnitType,
});

export default weatherConditionsType;
